'use client';

import { RefObject, Suspense, useState } from 'react';
import { Box } from '@wishket/design-system';
import dynamic from 'next/dynamic';

import ArticleDetailBottomToolbar from './ArticleDetailBottomToolbar';

const ArticleCommentsSectionClient = dynamic(
  () => import('@/widgets/ArticleCommentsSection')
);

interface ArticleToolbarCommentProps {
  id: string;
  title: string;
  commentListRef: RefObject<HTMLDivElement | null>;
}

const ArticleToolbarComment = ({
  id,
  title,
  commentListRef,
}: ArticleToolbarCommentProps) => {
  const [isCommentVisible, setIsCommentVisible] = useState(true);
  return (
    <>
      <ArticleDetailBottomToolbar
        id={id}
        handleCommentView={() => {
          setIsCommentVisible((prev) => !prev);
        }}
        articleTitle={title}
      />
      <Suspense
        fallback={
          <>
            {Array(2)
              .fill(null)
              .map((_, index) => (
                <Box
                  key={index}
                  className="h-[280px] w-full animate-pulse rounded-3xl bg-w-gray-50"
                />
              ))}
          </>
        }
      >
        <ArticleCommentsSectionClient
          id={id}
          isVisible={isCommentVisible}
          ref={commentListRef}
        />
      </Suspense>
    </>
  );
};

export default ArticleToolbarComment;
